'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.borderLookupTransformer = exports.imageLookupTransformer = exports.boxShadowLookupTransformer = exports.scaleLookupTransformer = exports.fontLookupTransformer = exports.gradientLookupTransformer = exports.colorLookupTransformer = undefined;

var _ramda = require('ramda');

var _dataLookupTransformer = require('../dataLookupTransformer');

var _dataLookupTransformer2 = _interopRequireDefault(_dataLookupTransformer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DATA_NODE_NAMES = ['color', 'gradient', 'font', 'scale', 'boxShadow', 'image', 'border'];

var _reduce = (0, _ramda.reduce)(function (acc, value) {
  return (0, _ramda.pipe)(_dataLookupTransformer2.default, (0, _ramda.assoc)(value + 'LookupTransformer', _ramda.__, acc))(value);
}, {})(DATA_NODE_NAMES),
    colorLookupTransformer = _reduce.colorLookupTransformer,
    gradientLookupTransformer = _reduce.gradientLookupTransformer,
    fontLookupTransformer = _reduce.fontLookupTransformer,
    scaleLookupTransformer = _reduce.scaleLookupTransformer,
    boxShadowLookupTransformer = _reduce.boxShadowLookupTransformer,
    imageLookupTransformer = _reduce.imageLookupTransformer,
    borderLookupTransformer = _reduce.borderLookupTransformer;

exports.colorLookupTransformer = colorLookupTransformer;
exports.gradientLookupTransformer = gradientLookupTransformer;
exports.fontLookupTransformer = fontLookupTransformer;
exports.scaleLookupTransformer = scaleLookupTransformer;
exports.boxShadowLookupTransformer = boxShadowLookupTransformer;
exports.imageLookupTransformer = imageLookupTransformer;
exports.borderLookupTransformer = borderLookupTransformer;


//////////////////
// WEBPACK FOOTER
// ./~/cssapi/lib/transformers/factory/dataLookupTransformers.js
// module id = 668
// module chunks = 168707334958949